import Vue from "vue";
import {VueMaskDirective} from "v-mask";
// import money from 'v-money'

Vue.directive("mask", VueMaskDirective);
// Vue.use(money, {precision: 2})
